import i18next from 'i18next';

export const CONSUMPTION_FREQUENCY = {
  DAILY: 'DAILY',
  PER_1000_CURRENCY: 'PER_1000_CURRENCY',
};

export const getNonSalesConsumptionFrequencies = (currency) => [
  {
    id: CONSUMPTION_FREQUENCY.DAILY,
    value: i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_DAILY'),
  },
  {
    id: CONSUMPTION_FREQUENCY.PER_1000_CURRENCY,
    value: i18next.t('ADMIN.STORES.CONSUMPTION_FREQUENCY_PER_1000_CURRENCY', {
      currency,
    }),
  },
];
